import Chip from "@web-ui/components/Chip";
import Tooltip from "@web-ui/components/Tooltip";
import { SAMPLE_EXPLANATION } from "./sample-notice";

/**
 * "Sample data" as a small chip beside a screen's own controls, with the banner's explanation one
 * hover, tap or Tab away (a dashboard keeps its first screen for numbers; Analytics keeps the banner).
 */
export function SampleChip({ shown }: { shown: boolean }) {
  if (!shown) return null;
  return (
    <Tooltip content={SAMPLE_EXPLANATION} place="bottom" className="!opacity-100">
      <span role="note" tabIndex={0} aria-label={`Sample data. ${SAMPLE_EXPLANATION}`} className="inline-flex rounded-full focus-visible:outline-2 focus-visible:outline-s-focus">
        <Chip tone="accent">Sample data</Chip>
      </span>
    </Tooltip>
  );
}
